/**
 * Custom hook to sync borrower bank draft data with Redux store
 * Consolidates all Redux dispatch operations for bank data
 */

import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { hydrateBankState } from "../../../features/merchant/bankSlice";

export interface BorrowerBankDraftData {
  bankName: string;
  accountNumber: string;
  accountType: string;
  swiftCode: string;
  accountHolderName: string;
  bankAddress: string;
  bankCountry: string;
  currency: string;
}

/**
 * Hook to sync borrower bank draft data with Redux store
 * Uses hydrateBankState for efficient bulk updates
 */
export const useBorrowerBankDraftSync = () => {
  const dispatch = useDispatch();

  /**
   * Sync all bank data to Redux store
   * Uses hydrateBankState to update all fields in a single dispatch
   */
  const syncBorrowerBankToRedux = useCallback(
    (data: BorrowerBankDraftData) => {
      dispatch(hydrateBankState(data));
    },
    [dispatch]
  );

  return { syncBorrowerBankToRedux };
};
